import React from "react";
import classNames from "classnames";
import Button, { ButtonSize, ButtonStyle } from "components/Button";
import * as styles from "./styles.module.scss";
const IconButton = ({ icon, small = false, imageClassName, classes, ...props }) => {
    const title = props.title ?? "";
    const renderedIcon = typeof icon === "string" ? (React.createElement("img", { src: icon, alt: title, className: imageClassName })) : React.isValidElement(icon) ? (icon) : (React.createElement(icon, { className: imageClassName, "aria-label": title }));
    return (React.createElement(Button, { ...props, style: ButtonStyle.Link, size: ButtonSize.ExtraSmall, label: renderedIcon, classes: {
            ...classes,
            root: classNames(classes?.root, styles["icon-button"], { [styles.small]: small }),
            labelContainer: classNames(classes?.labelContainer, styles["label-container"]),
        } }));
};
export default IconButton;
